import { Braces, MessageSquareText, Stethoscope } from "lucide-react";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { Button } from "@/components/ui/button";

export type DiffViewMode = "readable" | "json";

interface DiffToolbarProps {
  viewMode: DiffViewMode;
  onViewModeChange: (mode: DiffViewMode) => void;
  isXrayMode: boolean;
  onToggleXray: () => void;
  isXrayAvailable: boolean;
}

const DiffToolbar = ({
  viewMode,
  onViewModeChange,
  isXrayMode,
  onToggleXray,
  isXrayAvailable,
}: DiffToolbarProps) => (
  <div className="flex items-center gap-2">
    <div className="flex rounded-md border border-gray-200">
      <BasicTooltip content="Human-readable message view">
        <Button
          variant={viewMode === "readable" ? "default" : "ghost"}
          size="sm"
          className="rounded-r-none"
          onClick={() => onViewModeChange("readable")}
        >
          <MessageSquareText className="mr-1.5 h-4 w-4" />
          Messages
        </Button>
      </BasicTooltip>
      <BasicTooltip content="Raw JSON diff">
        <Button
          variant={viewMode === "json" ? "default" : "ghost"}
          size="sm"
          className="rounded-l-none border-l"
          onClick={() => onViewModeChange("json")}
        >
          <Braces className="mr-1.5 h-4 w-4" />
          JSON
        </Button>
      </BasicTooltip>
    </div>
    {isXrayAvailable && (
      <BasicTooltip
        content={isXrayMode ? "Hide expanded snippets" : "Expand snippets (X-Ray Mode)"}
      >
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full transition-all duration-200 active:scale-95"
          onClick={onToggleXray}
        >
          <Stethoscope
            className={`h-5 w-5 transition-colors ${
              isXrayMode ? "text-blue-600 hover:text-blue-700" : "text-gray-500 hover:text-gray-700"
            }`}
          />
        </Button>
      </BasicTooltip>
    )}
  </div>
);

export default DiffToolbar;
